import { createContext } from 'react';

type DragAndDropItemDelta = {
  x: number;
  y: number;
};

export type DraggableItemDeltas = {
  [name: string]: DragAndDropItemDelta;
};

export interface DroppableWrapperContextType {
  positions: DraggableItemDeltas;
}

const DroppableWrapperContext = createContext<
  DroppableWrapperContextType | undefined
>(undefined);

export default DroppableWrapperContext;
